import { useInstance, findDomFromVNode } from 'intact-vue-next';
export function useEqualWidth() {
  var instance = useInstance();
  instance.watch('show', setWidth, {
    presented: true
  });
  function setWidth(v) {
    if (!v) return;
    var menuElement = findDomFromVNode(instance.dropdownRef.value.menuVNode, true);
    var entity = findDomFromVNode(instance.$lastInput, true);
    menuElement.style.minWidth = entity.offsetWidth + "px";
  }
}